import React from "react";
import whiteWarpLogo from "../assets/images/Warspeed-Logo-White.png";
import FooterRughtText from "./FooterRughtText";
export default function Footer() {
  return (
    <div className="bg-gray-footer">
      <div className="flex justify-start flex-col md:flex-row pt-12 pb-6 px-4 md:px-0 ">
        <div className="md:mx-52 space-y-10">
          <div>
            <img src={whiteWarpLogo} alt="whiteWarpLogo" className="h-16" />
          </div>
          <div>
            <img
              src={
                "https://warpspeedmortgage.com/wp-content/uploads/2021/03/ehl@2x-293x300.png"
              }
              alt="whiteWarpLogo"
              className="h-10"
            />
          </div>
        </div>
        <FooterRughtText />
      </div>
      <div className="flex justify-start flex-col-reverse md:flex-row py-12 items-start px-4 md:px-0 ">
        <div className="md:mx-52 ">
          <p className="text-sm text-white">© 2023 Warp Speed Mortgage</p>
        </div>
        <div className="md:w-1/2 mb-8 md:mb-0 ">
          <ul className="flex justify-start md:justify-end space-x-1 flex-wrap">
            <li className="text-sm text-white ">
              <a href="https://warpspeedmortgage.com/">Home</a>
            </li>
            <div className="h-[14px] mt-[1px] border-l-[1px] border-white"></div>
            <li className="text-sm text-white">
              <a href="https://warpspeedmortgage.com/about/">About</a>
            </li>
            <div className="h-[14px] mt-[1px] border-l-[1px] border-white"></div>
            <li className="text-sm text-white">
              <a href="https://warpspeedmortgage.com/learning-center/">
                Learning Center
              </a>
            </li>
            <div className="h-[14px] mt-[1px] border-l-[1px] border-white"></div>
            <li className="text-sm text-white">
              <a href="https://warpspeedmortgage.com/contact/">Contact</a>
            </li>
            <div className="h-[14px] mt-[1px] border-l-[1px] border-white"></div>
            <li className="text-sm text-white">
              <a href="https://warpspeedmortgage.com/privacy-policy/">
                Privacy
              </a>
            </li>
            <div className="h-[14px] mt-[1px] border-l-[1px] border-white"></div>
            <li className="text-sm text-white">
              <a href="https://warpspeedmortgage.com/licensing/">Licensings</a>
            </li>
            <div className="h-[14px] mt-[1px] border-l-[1px] border-white"></div>
            <li className="text-sm text-white">
              <a href="https://www.nmlsconsumeraccess.org/">
                NMLS Consumer Access
              </a>
            </li>
            <div className="h-[14px] mt-[1px] border-l-[1px] border-white"></div>
            <li className="text-sm text-white">
              <a href="https://secure2.cpteller.com/portal/?op=RxAluX10MCkX">
                Make a Mortgage Payment
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
